import { ThemeProvider } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { ModalRoute } from "@src/appV2/redesign/Navigation/ModalRoute";
import { ModalTransitionSwitch } from "@src/appV2/redesign/Navigation/ModalTransitionSwitch";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { Route } from "react-router-dom";

import { PageWrapper } from "../../../components/PageWrapper";
import { PaymentDetailsPage } from "../../PaymentDetails/Page";
import { PAYMENT_DETAILS_PATH } from "../../PaymentDetails/paths";
import { EARNINGS_PATH } from "../paths";
import { EarningsPage } from "./Page";

export function EarningsContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper>
        <Route path={`${RootPaths.APP_V2_HOME}/${EARNINGS_PATH}`} component={EarningsPage} />
        <ModalTransitionSwitch modalKey={PAYMENT_DETAILS_PATH}>
          <ModalRoute
            path={`${RootPaths.APP_V2_HOME}/${PAYMENT_DETAILS_PATH}`}
            render={({ modalState }) => {
              return <PaymentDetailsPage modalState={modalState} />;
            }}
          />
        </ModalTransitionSwitch>
      </PageWrapper>
    </ThemeProvider>
  );
}
